import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Preloader from '../../components/Preloader/Preloader';
import { resetGlobalInterceptors } from '../../components/AxiosInterceptors/AxiosInterceptors';
import { resetApplicationStore } from '../../common/redux/purgeStore';
import { useLelyAuth } from '../../auth/useLelyAuth';

function LogoutPage() {
  const { logout: auth0Logout } = useLelyAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      auth0Logout({
        logoutParams: {
          returnTo: window.location.origin,
          federated: true,
        },
      }).then(() => {
        localStorage.removeItem('redirectUrl');
        resetGlobalInterceptors();
        dispatch(resetApplicationStore());
      });
    } catch (error) {
      console.log('logout error', error);
    }
  }, []);

  return <Preloader />;
}

export default LogoutPage;
